import { useEffect, useState } from 'react';

/** Breakpoint Tailwind `md` (768px) — aligné sur le design system du projet. */
const U2000_MD_MIN_MEDIA = '(min-width: 768px)';

/**
 * true lorsque la fenêtre est au moins largeur tablette (`md`).
 * Utilisé pour basculer layout (ex. onglets verticaux U3129).
 */
export function useU2000MinMdViewport(): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return true;
    }
    return window.matchMedia(U2000_MD_MIN_MEDIA).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const media = window.matchMedia(U2000_MD_MIN_MEDIA);
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return matches;
}
